<div class="paginator-container">
  <div class="paginator-info">
    <p>Mostrando: {{ quantity }} de {{ maxQuantity }}</p>
</div>
  <ngb-pagination class="paginator" size="sm" [(page)]="actualPage" [collectionSize]="maxQuantity" [maxSize]="maxSize" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="onChangePage(actualPage)">
  </ngb-pagination>
</div>